module.exports = __webpack_public_path__ + "media/dashboard/assets/images/facebook-70e500438d9ab24ff8cd5a5d18b38ceb.png";